<!--Success-->
<div *ngIf="identityCheckStatus === 'success'">
  <table cdk-table [dataSource]="AccountsList" class="card-container full-width">
    <ng-container cdkColumnDef="Kontobezeichnung">
      <th cdk-header-cell *cdkHeaderCellDef>Kontobezeichnung</th>
      <td cdk-cell *cdkCellDef="let element">
        <p style="font-size: 20px; font-weight: 600">
          {{ element.accountName }}
        </p>
      </td>
    </ng-container>
    <ng-container cdkColumnDef="Kontoinhaber">
      <th cdk-header-cell *cdkHeaderCellDef>Kontoinhaber</th>
      <td cdk-cell *cdkCellDef="let element">
        <p>{{ element.accountHolder }}</p>
      </td>
    </ng-container>
    <ng-container cdkColumnDef="IBAN">
      <th cdk-header-cell *cdkHeaderCellDef>IBAN</th>
      <td cdk-cell *cdkCellDef="let element">
        <p>{{ changeFormat(element.iban) }}</p>
      </td>
    </ng-container>
    <ng-container cdkColumnDef="Information">
      <th cdk-header-cell *cdkHeaderCellDef>Kontoinformationen</th>
      <td cdk-cell *cdkCellDef="let element">
        <p style="font-size: 20px; font-weight: 600">
          {{ element.accountName }}
        </p>
        <p>{{ element.accountHolder }}</p>
        <p>{{ changeFormat(element.iban) }}</p>
      </td>
    </ng-container>
    <form [formGroup]="incomeSpendingGroup">
      <ng-container cdkColumnDef="Income-Spending">
        <th cdk-header-cell *cdkHeaderCellDef>Geschäftskonto</th>
        <td cdk-cell *cdkCellDef="let element; let i = index">
          <app-checkbox
            [checkBoxControl]="incomeSpendingGroup.get(element.accountId)!"
            (click)="selectAtLeastOne(element.accountId, incomeSpendingGroup, $event)"
            [attr.data-cy]="'checkbox-konto-' + i"
          >
          </app-checkbox>
        </td>
      </ng-container>
    </form>
    <tr cdk-header-row *cdkHeaderRowDef="innerWidth > 1000 ? AccountsListdisplayedColumns : ResponsiveColumns"></tr>
    <tr
      cdk-row
      *cdkRowDef="let row; columns: innerWidth > 1000 ? AccountsListdisplayedColumns : ResponsiveColumns"
    ></tr>
  </table>

  <div class="d-flex justify-content-end">
    <ul>
      <li *ngIf="!areCheckboxesChecked">Bitte wählen Sie ein oder maximal zwei Konten aus.</li>
    </ul>
  </div>

  <div class="btn-container d-flex justify-content-between">
    <app-button
      data-cy="button_angebot_pruefen"
      color="primary"
      (click)="nextStep()"
      [disabled]="!areCheckboxesChecked"
    >
      Angebot prüfen<span class="material-icons notranslate" aria-hidden="true">arrow_forward_ios</span>
    </app-button>
  </div>
</div>

<!--in progress-->
<div class="card-container text-center" *ngIf="identityCheckStatus === 'inprogress'">
  <app-loader [text]="'FINAPI.BANKACCOUNTS_LOADER_TEXT'" [subText]="'FINAPI.BANKACCOUNTS_LOADER_SUBTEXT'"></app-loader>
</div>

<!--failed-->
<div class="card-container" *ngIf="identityCheckStatus === 'failed'">
  <p>failed</p>
</div>
